export default __webpack_public_path__ + "static/media/Tube-assembly-vibration-absorber.a23b389f.jpg";